import { useQuery } from '@apollo/client';
import GET_FLIGHTS_CARDS from './flightsCards.gql';

export interface IFlightsCard {
  code: string;
  name: string;
  category: string;
  naverPaySaving: number;
}
interface IData {
  flightsCards: IFlightsCard[];
}

/**
 * FLIGHTS_CARDS는 항공권 어드민 > 항공 정보 관리 > 결제수단(B code) 관리 메뉴에서 등록됨
 */
const useFlightsCards = () => {
  const { data } = useQuery<IData>(GET_FLIGHTS_CARDS);
  return data?.flightsCards || [];
};

export default useFlightsCards;
